import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TrackingService, CurrencyChangerService, FlightService } from '@clooper/core';
import { faHouseUser, faUsers, faChild, faBaby, faCat, faSearch, faSlidersH, faAngleDown, faCalendarPlus, faAngleUp, faPlaneDeparture, faPlaneArrival, faPlane, faPlaneAlt } from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import  iata from '../iata-codes.json';


@Component({
  selector: 'app-round-trip-form',
  templateUrl: './round-trip-form.component.html',
  styleUrls: ['../flights-search-bar.component.scss', './return-trip-form.component.scss']
})
export class RoundTripFormComponent implements OnInit {
  @Output() onsearch: EventEmitter<any> = new EventEmitter();

  minDate: Date;

  occupant_types = [
    { name: 'adults', icon: faUsers, subText: '', default: 1, max: 9 },
    { name: 'children', icon: faChild, subText: '(2-17 years)', default: 0, max: 9 },
    { name: 'infants', icon: faBaby, subText: '(Under 2 years)', default: 0, max: 9 },
    // { name: 'pets', icon: faCat, subText: '', default: 0 },
  ]

  occupant_form_array: { [x: string]: FormControl; }[] = []
  form: FormGroup
  dateRange: Date[];

  /** Boolean variable for enabling and disabling the search bar */
  isSearchBtnEnabled: boolean = false;

  filter: any = {
    // search: true
  };

  icons = {
    search: faSearch,
    sliderH: faSlidersH,
    caretDown: faAngleDown,
    calendar: faCalendarPlus,
    caretUp: faAngleUp,
    users: faUsers,
    departure: faPlaneDeparture,
    arrival: faPlaneArrival,
    plane: faPlane,
    planeUp: faPlaneAlt
  }
  latlng: any
  searchRadius = 20;
  routerSubs: any;
  searchValue: string;
  checkIn: Date;
  checkOut: Date;
  queryParamsSubs: Subscription;
  selectedCurrency: string = 'GBP';
  airportFromAutoComplete: any[] = [];
  airportToAutoComplete: any[] = [];
  searchForm = new FormGroup({
    flightFrom: new FormControl('', [Validators.required]),
    flightTo: new FormControl('', [Validators.required]),

  });
  
  selectedAirport: any;
  flightToAirport: any;
  flightFromAirport: any;
  showToTrigger: boolean = false;


  constructor(
    private route: ActivatedRoute,
    private tracker: TrackingService,
    private fb: FormBuilder,
    private router: Router,
    private modalService: BsModalService,
    private currency: CurrencyChangerService,
    private flightService: FlightService,

  ) {
    const data = this.currency.getSelectedCurrency()
    if (data !== null) {

      this.selectedCurrency = data?.currency;
    } else {
      this.selectedCurrency = 'GBP'
    }

    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());

     this.occupant_form_array = this.occupant_types.map(occupant_type => {
  return {
    [occupant_type.name]: new FormControl(occupant_type.default, [
      Validators.min(0), 
      Validators.max(occupant_type.max) 
    ]),
  }
});
    let occupant_form = Object.assign({}, ...this.occupant_form_array);
    this.form = this.fb.group({
      cabin: new FormControl('economy', [Validators.required]),
      check_in: new FormControl('', []),
      check_out: new FormControl('', []),
      occupants: new FormControl('', []),
      ...occupant_form
    })


this.queryParamsSubs = this.route.queryParams.subscribe((params) => {
  this.latlng = params.latlng
  this.searchValue = params.s || ''

  if (+params.checkIn && +params.checkOut) {
    this.checkIn = new Date(+params.checkIn)
    this.checkOut = new Date(+params.checkOut)
    this.dateRange = [this.checkIn, this.checkOut]
  }

  const flights = params.flights ? JSON.parse(params.flights) : []
  const flightsInfo = params.flightsInfo ? JSON.parse(params.flightsInfo) : []

  this.dateRange = [moment(flights[0]?.departure_date).toDate(), moment(flights[1]?.departure_date).toDate()];

  this.flightFromAirport = flights[0]?.origin_airport
  this.flightToAirport = flights[0]?.destination_airport

  if (this.flightFromAirport && this.flightToAirport) {
    this.searchForm.controls.flightFrom.setValue(flightsInfo[0]?.origin_airport_name, { emitEvent: false });
    this.searchForm.controls.flightTo.setValue(flightsInfo[0]?.destination_airport_name, { emitEvent: false });
  }

  + params.adults ? this.form.controls['adults'].setValue(+params.adults) : null;
  +params.children ? this.form.controls['children'].setValue(+params.children) : null;
  +params.pets ? this.form.controls['pets'].setValue(+params.pets) : null;
  +params.infants ? this.form.controls['infants'].setValue(+params.infants) : null;
  params.cabin ? this.form.controls['cabin'].setValue(params.cabin) : null;

  if (params.adults || params.infants || params.pets || params.children)
    this.constructString()
})

  }


  ngOnInit(): void {
    this.searchForm.controls.flightFrom.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((term) => {
        this.searchAirports(term as string);
      });

    this.searchForm.controls.flightTo.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((term) => {
        this.searchToAirports(term as string);
      });
    this.constructString()

  }

  ngOnDestroy(): void {
    // this.routerSubs.unsubscribe()
    this.queryParamsSubs.unsubscribe()
  }

  reset() {
    this.filter = {
      // search: true
    }
  }



  radiusChange(radius: number) {
    this.searchRadius = radius || 10;
    this.filter = { ...this.filter, radius };
  }

  /** This method checks if the occupants field and check-in checkout date fields are truthy then it update the boolean variable for enabling the search form.*/
  updateSelection(): void {
    const occupants = this.form.get('occupants')?.value;
    if (occupants && this.dateRange) this.isSearchBtnEnabled = true;
  }



  search(params?: any) {
    const paginationParams = { page: 1, size: 20, currency: this.selectedCurrency }
    const { adults, children, pets, infants, cabin } = this.form.value
    const queryParams: any = {
      ...this.filter,
      ...paginationParams,
      adults, children, pets, infants, cabin,
      // checkIn: this.dateRange ? this.dateRange[0]?.getTime() : 0,
      // checkOut: this.dateRange ? this.dateRange[1]?.getTime() : 0,
      search_type: 'RoundTrip',
      flights: JSON.stringify([
        {
          "origin_airport": this.flightFromAirport?.iata || this.flightFromAirport,
          "destination_airport": this.flightToAirport?.iata || this.flightToAirport,
          "departure_date": moment(this.dateRange[0]).format('YYYY-MM-DD'),
        },
        {
          "origin_airport": this.flightToAirport?.iata || this.flightToAirport,
          "destination_airport": this.flightFromAirport?.iata || this.flightFromAirport,
          "departure_date": moment(this.dateRange[1]).format('YYYY-MM-DD'),
        }
      ]),
      flightsInfo: JSON.stringify([
        {
          'origin_airport_name': this.searchForm.value.flightFrom,
          'destination_airport_name': this.searchForm.value.flightTo,
        },
        {
          'origin_airport_name': this.searchForm.value.flightTo,
          'destination_airport_name': this.searchForm.value.flightFrom,
        }
      ])
    }
    this.router.navigate(['/flights'], { queryParams })
    this.onsearch.emit(queryParams)
  }


  locationChange(data: any, type: string) {
    const latlng = data.latlng.join(',');
    this.latlng = data.latlng.join(',');
    this.filter = { ...this.filter, latlng, s: data.s };

  }

  filters(params: any) {
    this.filter = { ...this.filter, ...params };
  }

  locationInputChange(event: any, type: string) {
    if (!event.value) {

    }
  }


increment(name: string) {
   if (
    name === 'infants' &&
    +this.form.value.infants >= +this.form.value.adults
  ) {
    return;
  }

  const max = this.occupant_types.find(o => o.name === name)?.max;

  if (max !== undefined && +this.form.value[name] >= max) {
    return;
  }

  this.form.controls[name].setValue(+this.form.value[name] + 1);
  this.constructString();
}

decrement(name: string) {
  const min = name === 'adults' ? 1 : 0;

  // If adults is reduced, clamp infants to adults
  if (
    name === 'adults' &&
    +this.form.value.infants > +this.form.value.adults - 1
  ) {
    this.form.controls.infants.setValue(+this.form.value.adults - 1);
  }

  if (+this.form.value[name] <= min) {
    return;
  }

  this.form.controls[name].setValue(+this.form.value[name] - 1);
  this.constructString();
}


  // increment(name: string) {
  //   this.form.controls[name].setValue(+this.form.value[name] + 1)
  //   this.constructString()

  // }

  // decrement(name: string) {
  //   if (+this.form.value[name] > 0) {
  //     this.form.controls[name].setValue(+this.form.value[name] - 1)
  //     this.constructString()
  //   }
  // }

  constructString() {
    let string = ` ${this.form.value['adults'] ? this.form.value['adults'] + (this.form.value['adults'] > 1 ? " Adults," : " Adult,") : ''} ${this.form.value['children'] ? this.form.value['children'] + (this.form.value['children'] > 1 ? " Children," : " Child,") : ''} ${this.form.value['pets'] ? this.form.value['pets'] + (this.form.value['pets'] > 1 ? " Pets," : " Pet,") : ''} ${this.form.value['infants'] ? this.form.value['infants'] + (this.form.value['infants'] > 1 ? " Infants," : " Infant,") : ''}`
    string = string.trim()
    if (string.charAt(string.length - 1) === ',') {
      let temp = string.split('')
      temp.splice(string.length - 1)
      string = temp.join("")
    }
    this.form.controls['occupants'].setValue(string)
  }

  searchAirports(event: any) {
const d = iata.filter((item: any) => item.name.toLowerCase() === event.toLowerCase() || item.code.toLowerCase() === event.toLowerCase() )
     const leadAirport = d.map((item: any) => {
      return {
        airport: `${item.name}, ${item?.country}`,
        iata: item.code
      }
     })
    if (event.length !== 0) {
      const payload = {
        key: event
      }
      this.flightService.getAirports(payload).subscribe({
        next: (res: any) => { 
          this.airportFromAutoComplete = this.mergeLeadAirportWithOthers(leadAirport, res.data)
        },
        error: (err: any) => {
          this.airportFromAutoComplete = leadAirport.length > 0 ? leadAirport : [];
          }
        }

  
    )
    }
  }

  searchToAirports(event: any) {
const d = iata.filter((item: any) => item.name.toLowerCase() === event.toLowerCase() || item.code.toLowerCase() === event.toLowerCase() )
console.log(d)
     const leadAirport = d.map((item: any) => {
      return {
        airport: `${item.name}, ${item?.country}`,
        iata: item.code
      }
     })
    if (event.length !== 0) {
      const payload = {
        key: event
      }
      this.flightService.getAirports(payload).subscribe({
        next: (res: any) => { 
          this.airportToAutoComplete = this.mergeLeadAirportWithOthers(leadAirport, res.data)
        },
        error: (err: any) => {
          this.airportToAutoComplete = leadAirport.length > 0 ? leadAirport : [];
          }
        }

  
    )
    }
  }

  
  mergeLeadAirportWithOthers(leadAirportArray: any, resultsArray: any) {
    console.log(leadAirportArray, resultsArray);
  if (!leadAirportArray || leadAirportArray.length === 0) {
    return resultsArray;
  }
  const first = leadAirportArray[0];

  const filteredB = resultsArray.filter((item: any) => item.iata !== first.iata);
  return [first, ...filteredB];
}


  selectAirport(airport: any) {
    this.flightFromAirport = airport;
    this.searchForm.controls.flightFrom.setValue(airport?.airport + " (" + airport.iata + ")", { emitEvent: false })
  }

  selectToAirport(airport: any) {
    this.flightToAirport = airport;
    if (JSON.stringify(this.flightFromAirport) === JSON.stringify(this.flightToAirport)) {
      this.showToTrigger = true;
      setTimeout(() => {
        this.showToTrigger = false;

      }, 3000);
      this.searchForm.controls.flightTo.setValue('', { emitEvent: false })
    } else {

      this.searchForm.controls.flightTo.setValue(airport?.airport + " (" + airport.iata + ")", { emitEvent: false })
    }
  }



}
